import React, { Component } from 'react';
import '../style/project.css';
import { Link } from 'react-router-dom';
import Lightbox from 'react-image-lightbox';

export class Project extends Component {
	constructor(data) {
		super();
		this.handleKeyDown = ({ keyCode }) => {
            if (!this.state.bigImage) {
                if (keyCode === 37) {
                    this.fade(this.state.image > 0 ? this.state.image - 1 : this.project.images.length - 1);
                } else if (keyCode === 39) {
                    this.fade((this.state.image + 1) % this.project.images.length);
                }
            }
		};
	}

	newText = '';

	state = {
		image: 0,
        fading: false,
        bigImage:false
	};

	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleKeyDown, false);
	}

	componentWillMount() {
		document.addEventListener('keydown', this.handleKeyDown, false);
		this.project = this.props.data.projects.filter((project) => project.name === this.props.match.params.name)[0];
		if (this.project) document.title = this.project.name;
	}

	fade(image) {
		if (this.state.image !== image) {
			this.setState({ fading: true });
			setTimeout(() => this.setState({ image, fading: false }), 500);
		}
	}

	render() {
        if (!this.project) return <div> project not found </div>;
        console.log(this)
		return (
            
			<div className="project">
                {this.state.bigImage &&
                    <Lightbox
                        mainSrc = {'https://s3-us-west-2.amazonaws.com/cobbarch-data/images/projects/' +
                            this.project.images[this.state.image].name.replace(/ /g, '+').toLowerCase()}
                        nextSrc = { (this.state.image < this.project.images.length - 1) ? 'https://s3-us-west-2.amazonaws.com/cobbarch-data/imagess/projects/' +
                            this.project.images[this.state.image + 1].name.replace(/ /g, '+').toLowerCase() : null}
                        prevSrc = { (this.state.image > 0) ? 'https://s3-us-west-2.amazonaws.com/cobbarch-data/imagess/projects/' +
                            this.project.images[this.state.image - 1].name.replace(/ /g, '+').toLowerCase() : null}
                        onCloseRequest={() => this.setState({ bigImage: false })}
                        onMoveNextRequest = {() => this.setState({image: this.state.image + 1})}
                        onMovePrevRequest = {() => this.setState({image: this.state.image - 1})}
                    />
                }
				<div className="details">
					<h2>{this.project.name}</h2>
					<p>Location: {this.project.location}</p>
					<p>Date: {this.project.date}</p>
					<p>Principal in Charge: {this.project.principal}</p>
					<div>
						<p className="team">Project Team: </p>
						<ul>
							{this.project.architect.map((arc, idx) => (
								<div key={'architect' + idx} className="person">
									<li key={'arc' + idx} className="architect">
										<Link style={{ color: '#dcdcdc' }} to="/contact">
											{arc}
										</Link>
									</li>
								</div>
							))}
						</ul>
					</div>
					<p style={{ marginTop: '8em', fontSize: '.6em' }}> Ⓒ{' ' + this.project.cpy}</p>
				</div>
				<a rel="noopener noreferrer" target="_blank">
					<img
						alt={this.project.name + this.state.image}
                        className={this.state ? this.state.fading ? 'fullImage fading' : 'fullImage' : 'fullImage'}
                        onClick={() =>this.setState({
                            bigImage: true
                        })}
						src={
							'https://s3-us-west-2.amazonaws.com/cobbarch-data/images/projects/' +
							this.project.images[this.state.image].name.replace(/ /g, '+').toLowerCase()
						}
					/>
				</a>

				<div className="slideshow">
					<ul>
						{this.project.images.map((image, idx) => (
							<li
								key={'img' + idx}
								className="preview"
								style={{
									backgroundImage:
										'url(\"https://s3-us-west-2.amazonaws.com/cobbarch-data/images/projects/' +
										image.name.replace(/ /g, '%20').toLowerCase() +
										'\")',
									opacity: idx === this.state.image ? 0.5 : 1,
									animation: idx === this.state.image ? 'partFade .2s linear' : 'none'
								}}
								onClick={() => this.fade(idx)}
							/>
						))}
					</ul>
				</div>
			</div>
		);
	}
}

export class MobileProject extends Project {
	componentWillMount() {
		this.project = this.props.data.projects.filter((project) => project.name === this.props.match.params.name)[0];
		if (this.project) {
			document.title = this.project.name;
		}
	}

	render() {
		return (
			<div className="mobileProject">
				<div className="details" style={{ fontSize: '.6em' }}>
					<h4>{this.project.name}</h4>
					<p>location: {this.project.location}</p>
					<p>date: {this.project.date}</p>
					<p>principal in charge: {this.project.principal}</p>
					<p>project team: {this.project.architect.join(', ')} </p>
				</div>
				{this.project.images.map((image, idx) => (
					<img
						key={'image' + idx}
						alt={this.project.name + this.state.image}
						style={{ width: '100%', marginBottom: '5px' }}
						src={`https://s3-us-west-2.amazonaws.com/cobbarch-data/images/projects/${image.name
							.replace(/ /g, '+')
							.toLowerCase()}`}
					/>
				))}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/project.js